<template>
  <ShopModel @save="shop => $emit('add', shop)">
    <div class="p-2 cursor-pointer border border-gray-200 text-gray-600 hover:bg-gray-50 duration-200 border-dashed rounded-lg flex items-center space-x-2">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 shrink-0" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
      </svg>
      <span>New physical shop</span>
    </div>
  </ShopModel>
</template>

<script>

import ShopModel from "./ShopModel"

export default {
  components: {
    ShopModel,
  },
}

</script>

